import React, { useMemo } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/customTooltipStyle';
import { PopperPlacementType, Tooltip, makeStyles } from '@material-ui/core';
import { BodySBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';

//@ts-ignore
const useStyles = makeStyles(styles);

interface ITermsAndConditionsTooltipProps {
	placement?: PopperPlacementType;
	children: React.ReactElement | null;
}

const TermsAndConditionsTooltip = ({ placement = 'right', children }: ITermsAndConditionsTooltipProps) => {
	const classes = useStyles();

	const tooltipText = useMemo(() => {
		return (
			<div>
				<BodySBold color="brand" disableMargin>
					{translate('number.services.terms.conditions')}
				</BodySBold>
			</div>
		);
	}, []);

	return (
		<Tooltip
			arrow
			placement={placement}
			classes={{ tooltip: classes.termsAndConditionsTooltip }}
			title={<div className={classes.tooltip}>{children}</div>}
		>
			{tooltipText}
		</Tooltip>
	);
};

export default TermsAndConditionsTooltip;
